import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { registerPhoneAudioReference } from 'flow/actions/phone-actions';
import { ToneGenerator } from 'resources/tone-generator';
import { getPreferredAudioOutputVolume } from 'flow/utils/browser-utils';
import { fetchConnectedMediaDevices } from 'flow/actions/headset-actions';
import { setActiveMeetingAudioReferenceAction as _setActiveMeetingAudioReferenceAction } from 'flow/actions/meeting-actions';
import { isLocalFocusedCallSessionEstablished } from 'flow/selectors/call-selectors';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var AudioReference = /*#__PURE__*/function (_React$PureComponent) {
  function AudioReference(props) {
    var _this;
    _classCallCheck(this, AudioReference);
    _this = _callSuper(this, AudioReference, [props]);
    _this.audioRef = /*#__PURE__*/React.createRef();
    _this.conferenceAudioRef = /*#__PURE__*/React.createRef();
    _this.toneGeneratorRef = /*#__PURE__*/React.createRef();
    _this.toneGeneratorAdditionalRingtoneRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  _inherits(AudioReference, _React$PureComponent);
  return _createClass(AudioReference, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.handleRegisterPhoneAudioReference(this.audioRef.current);
      this.props.setActiveMeetingAudioReferenceAction(this.conferenceAudioRef.current);
      this.audioRef.current.volume = getPreferredAudioOutputVolume();
      this.props.attachMediaDevices();
      ToneGenerator.setOutputElement(this.toneGeneratorRef.current);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("audio", {
          ref: this.audioRef,
          autoPlay: true
        }), /*#__PURE__*/_jsx("audio", {
          ref: this.conferenceAudioRef,
          autoPlay: true,
          muted: !!this.props.currentSessionActive
        }), /*#__PURE__*/_jsx("audio", {
          ref: this.toneGeneratorRef,
          autoPlay: true
        })]
      });
    }
  }]);
}(React.PureComponent);
_defineProperty(AudioReference, "propTypes", {
  handleRegisterPhoneAudioReference: PropTypes.func.isRequired,
  attachMediaDevices: PropTypes.func.isRequired,
  setActiveMeetingAudioReferenceAction: PropTypes.func.isRequired,
  currentSessionActive: PropTypes.bool
});
var mapStateToProps = function mapStateToProps(state) {
  var currentSessionActive = isLocalFocusedCallSessionEstablished(state);
  return {
    currentSessionActive: currentSessionActive
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleRegisterPhoneAudioReference: function handleRegisterPhoneAudioReference(ref) {
      dispatch(registerPhoneAudioReference(ref));
    },
    attachMediaDevices: function attachMediaDevices() {
      dispatch(fetchConnectedMediaDevices);
    },
    setActiveMeetingAudioReferenceAction: function setActiveMeetingAudioReferenceAction(audioReference) {
      return dispatch(_setActiveMeetingAudioReferenceAction(audioReference));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AudioReference);